import { render, staticRenderFns } from "./EditCsvDownloads.vue?vue&type=template&id=04bda770&scoped=true"
import script from "./EditCsvDownloads.vue?vue&type=script&lang=js"
export * from "./EditCsvDownloads.vue?vue&type=script&lang=js"
import style0 from "./EditCsvDownloads.vue?vue&type=style&index=0&id=04bda770&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04bda770",
  null
  
)

export default component.exports